import * as React from "react";
import { Gap, paginate } from "../helpers/pagination";
import { PaginationData } from "../types";
import styles from "./pagination.module.sass";

export type PageChangeHandler = (newPage: number) => void;

const PaginationGap = (): JSX.Element => <li>…</li>;

type CurrentPageProps = {
  number: number;
};

const CurrentPage = ({ number }: CurrentPageProps): JSX.Element => (
  <li className={styles.activePage}>{number}</li>
);

type PageLinkProps = {
  number: number;
  href: string;
  onPageChange: PageChangeHandler;
};

const PageLink = ({
  number,
  href,
  onPageChange,
}: PageLinkProps): JSX.Element => (
  <li>
    <a
      href={href}
      onClick={(event) => {
        event.preventDefault();
        onPageChange(number);
      }}
    >
      {number}
    </a>
  </li>
);

type PaginationProps = PaginationData & {
  onPageChange: PageChangeHandler;
  makeLink?: (pageNumber: number) => string;
};

export const Pagination = ({
  onPageChange,
  currentPage,
  perPage,
  resultsCount,
  makeLink = (pageNumber) => `./?page=${pageNumber}`, // TODO remove the default and generate proper links
}: PaginationProps): JSX.Element | null => {
  const pages = paginate(currentPage, perPage, resultsCount);

  if (pages.length <= 1) {
    return null;
  }

  return (
    <nav className={styles.paginationList}>
      {pages.map((page, i) => {
        if (page === Gap) return <PaginationGap key={`gap-${i}`} />;
        else if (page === currentPage)
          return <CurrentPage key={page} number={page} />;
        else
          return (
            <PageLink
              key={page}
              onPageChange={onPageChange}
              number={page}
              href={makeLink(page)}
            />
          );
      })}
    </nav>
  );
};
